import { render, staticRenderFns } from "./codigo-practicas-comerciales.vue?vue&type=template&id=b9979a58&lang=html&"
import script from "./codigo-practicas-comerciales.vue?vue&type=script&lang=js&"
export * from "./codigo-practicas-comerciales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports